/*
 * Progress indicator for the product card image carousel.
 *
 * The track is a native scroll-snap list, so the active slide is derived from
 * scrollLeft rather than from any slider state. Two custom properties drive the
 * bar: --card-carousel-count sizes it, --card-carousel-index places it.
 *
 * Scroll does not bubble, so the listener is registered in the capture phase on
 * document. That keeps the indicator working for cards injected later — the
 * product grid is replaced wholesale whenever a facet changes — without needing
 * to rebind anything.
 */
(function () {
  const TRACK = 'card-media-carousel__track';

  function update(track) {
    const carousel = track.closest('.card-media-carousel');
    if (!carousel) return;

    const slides = track.children;
    const count = slides.length;
    if (count < 2) {
      carousel.style.setProperty('--card-carousel-count', 1);
      carousel.style.setProperty('--card-carousel-index', 0);
      return;
    }

    const step = slides[1].offsetLeft - slides[0].offsetLeft || track.clientWidth;
    const index = Math.min(count - 1, Math.max(0, Math.round(track.scrollLeft / step)));

    carousel.style.setProperty('--card-carousel-count', count);
    carousel.style.setProperty('--card-carousel-index', index);
  }

  function refreshAll(root) {
    (root || document).querySelectorAll('.' + TRACK).forEach(update);
  }

  document.addEventListener(
    'scroll',
    function (event) {
      const target = event.target;
      if (target instanceof Element && target.classList.contains(TRACK)) update(target);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      refreshAll();
    });
  } else {
    refreshAll();
  }

  // Facet changes swap out the grid; pick up whatever landed in it.
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList.contains(TRACK)) update(node);
        else refreshAll(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
